import { render, staticRenderFns } from "./teamDialog.vue?vue&type=template&id=054bd700"
import script from "./teamDialog.vue?vue&type=script&lang=js"
export * from "./teamDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports